


























































































 import Vue from 'vue'
 import oss from '../../api/oss.js'
import { audio } from '@/api/audio'
 import uploadTwoCrops from '../../components/uploadTwoCrops.vue'
 import wtTags from '../../components/tags.vue'
 import store from '@/store/index'
 import {HttpRequestOptions} from "element-ui/types/upload";
 import {CategoryData, PrePodCastData, PreSingleData, SingleData} from '@/interface/interfaceAudio.js'
 import {ElForm} from "element-ui/types/form";
 interface Data {
     rules: any;                         // 校验规则
     item: PreSingleData;                // 节目对象
     tags: string[];                     // 标签
     podCastList: PrePodCastData[]       // 播客列表
     categoryList: CategoryData[]        // 分类列表
     props: any;                         // 级联选择器样式，详见 https://element.eleme.io/#/zh-CN/component/cascader
     showProgress: boolean;              // 显示进度条
     fileSize: number;                   // 音频文件大小
 }
 export default Vue.extend({
     components: {
         uploadTwoCrops,
         wtTags
     },
     data(): Data {
         return {
             rules: {
                 url: [
                     {
                         required: true, message: '请上传音频文件', trigger: 'change'
                     }
                 ],
                 title: [
                     {
                         required: true, message: '请输入节目名称', trigger: 'blur'
                     }
                 ],
                 pod_cast_id: [
                     {
                         required: true, message: '请选择播客', trigger: 'change'
                     }
                 ],
                 selCategory: [
                     {
                         required: true, message: '请选择分类', trigger: 'change'
                     }
                 ]
             },
             item: {
                 pod_cast_id: 0,
                 pic_url: '',
                 pic_url2: '',
                 url: '',
                 title: '',
                 duration: 0,
                 selCategory: [],
                 status: 1,
                 file_size: 0
             },
             tags: [],
             podCastList: [],
             categoryList: [],
             props: {
                 multiple: true,
                 label: 'category_name',
                 value: 'id',
                 children: 'sub'
             },
             showProgress: false,
             fileSize: 0
         }
     },

     computed: {
         progress(): number {
             return store.state.single.progress
         },
         currFileSize(): number {
             return +(this.fileSize * this.progress / 100).toFixed(2);
         },
     },
     methods: {
         // 自定义oss上传
         uploadFile(param: HttpRequestOptions) {
             this.showProgress = true;
             let url = URL.createObjectURL(param.file);
             // 获取音频时长
             let player: HTMLAudioElement = new Audio(url)
             player.addEventListener('durationchange', () => {
                 this.item.duration = Math.round(player.duration * 1000);
                 URL.revokeObjectURL(url);
             })
             oss.putUseBucket(param.file).then(response => {
                 let url = response.res.requestUrls[0];
                 if (url.indexOf('?') !== -1) {
                     url = url.substring(0, url.indexOf('?'));
                 }
                 this.$set(this.item, 'url', url)
             }).catch(err => {
                 throw err
             })
         },
         // 删除文件
         deleteUrl() {
             this.showProgress = false
             store.commit('updateProgress', 0);
             this.$set(this.item, 'url', '');
         },
         // 分类列表
         getCategoryList() {
             audio.getCategory().then(res => {
                 this.categoryList = res.data
             })
         },
         // 获取播客列表
         getPodCastList() {
             audio.getPodCastAll().then(res => {
                 this.podCastList = res.data
             })
         },
         // 获取页面信息
         getCreateSingle() {
             const id = +this.$route.params.id;
             audio.getSingleDetail(id).then(res => {
                 this.item = res.data
                 if (this.item.tags) {
                     this.tags = this.item.tags.split('|')
                 }
             })
         },
         // 保存
         save (status: number) {
             (this.$refs['item'] as ElForm).validate(async (valid: boolean) => {
                 if (valid) {
                     if (this.$route.params.id) {
                         if (this.item.status !== 1) {
                             this.item.status = 2
                         }
                         await audio.editSingle(this.item)
                     } else {
                         // 创建
                         console.log(this.item.selCategory);
                         let categories: number[] = [];
                         let subCategories: number[] = [];
                         this.item.selCategory.forEach(arr => {
                             categories.push(arr[0]);
                             subCategories.push(arr[1]);
                         });
                         /*this.item.categories = Array.from(new Set(categories));
                         this.item.sub_categories = subCategories;*/
                         this.item.status = status
                         let data: SingleData = {
                             categories: Array.from(new Set(categories)),
                             sub_categories: subCategories,
                             ...this.item,
                         }
                         await audio.createSingle(data)
                     }
                     this.$router.go(-1)
                 }
             })
         },
         // 上传文件之前的获取文件信息
         beforeAvatarUpload(file: File) {
             if (file.type.indexOf('audio/') > -1 || file.type.indexOf('video/') > -1) {
                 this.item.file_size = file.size;
                 this.fileSize = file.size
                 return true
             }
             this.$alert('请选择正确的音频文件上传');
             return false
         },

         changeImg(data: {imgUrl2: string, imgUrl1: string}) {
             this.$set(this.item, 'pic_url', data.imgUrl2);
             this.$set(this.item, 'pic_url2', data.imgUrl1);
         },
         handleTags(value: string[]) {
             this.item.tags = value.join('|')
         },
         // 返回
         goback() {
             this.$router.go(-1);
         }
     },
     created() {
         if (this.$route.params.id) {
             this.getCreateSingle();
         }
         if (this.$route.query.album_id) {
             this.item.pod_cast_id = +this.$route.query.album_id;
         }
         this.getPodCastList();
         this.getCategoryList();
         this.$store.commit('updateProgress', 0)
     },
     filters: {
         // 文件大小改成按M显示
         getFileSizeM(val: number): number {
             return +(val/1024/1024).toFixed(2);
         }
     }
 })
